module.exports = __webpack_public_path__ + "img/chi-geneve.9b58f27e.jpg";